module.exports = __webpack_public_path__ + "static/img/huaketai.f41a1f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/huaketai.jpg
// module id = y8Gy
// module chunks = 1